<template>
  <AdminSettings />
</template>

<style scoped>
::v-deep .container--fluid {
  padding: 0px !important;
}
</style>
<script>
// @ is an alias to /src

import Vue from "vue";
import AdminSettings from "@/components/admin/AdminSettings.vue";
import { SplitterPlugin } from "@syncfusion/ej2-vue-layouts";
import {
  GridPlugin,
  Freeze,
  Resize,
  Sort,
  Page,
  Toolbar,
  Group,
  Search,
  Edit,
} from "@syncfusion/ej2-vue-grids";
Vue.use(GridPlugin);
Vue.use(SplitterPlugin);

export default {
  name: "Admin",
  components: {
    AdminSettings,
  },
};
</script>
